import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Navbar from "../layouts/nav";
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

export default function Contactuus(){

    const [files, setFiles] = useState('');
   
    async function contactUs(e){
        e.preventDefault();
        // const data = new FormData();
        // data.set('firstname', firstname);
        // data.set('lastname', lastname);
        // data.set('email', email);
        // data.set('message', message);
        // data.set('files', files[0]);
        const response = await fetch ('https://biouniverse-api.vercel.app/contact',{
            method:'POST',
            body: JSON.stringify({firstname, lastname, email, message}),
	        headers: {'Content-Type': 'application/json'}
        });
        if(response.status === 200){
            toast.success('Message Sent!');
            setTimeout(() => {
                setFirstname('');
                setLastname('');
                setEmail('');
                setMessage('');

                const divs = document.querySelectorAll('.contact_input-wrap');
                for(const div of divs){
                    setfocus(div.classList.remove('contact_focus'));
                    setEmpty(div.classList.remove('contact_not-empty'));
                }
            } , 100);
        }else{
            toast.error('An Error Occurred!');
        }
    }

    const [firstname, setFirstname] = useState('');
    const [lastname, setLastname] = useState('');
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');


    useEffect(() => {
		// List of JS files to reload
		const jsFiles = [
		  'assets/js/custom.js',
		];
	
		// Create script elements for each JS file
		jsFiles.forEach((filePath) => {
		  const script = document.createElement('script');
		  script.src = filePath;
		  script.async = true;
		  document.body.appendChild(script);
		});
	
		// Clean up the script elements when the component unmounts
		return () => {
		  jsFiles.forEach((filePath) => {
			const script = document.querySelector(`[src="${filePath}"]`);
			if (script) {
			  document.body.removeChild(script);
			}
		  });
		};
	  }, []);

    const [theme, setTheme] = useState('none');
    const [transition, setTrans] = useState('none');
    const [empty, setEmpty] = useState('none');
    const [blur, setfocus] = useState('none');

    function changeTheme(e){
        const allElements = document.querySelectorAll('*');
        setTheme(document.body.classList.toggle('contact_dark'));
        allElements.forEach(ele => {
            setTrans(ele.classList.add('contact_transition'));
            setTimeout(() => {
            setTrans(ele.classList.remove('contact_transition'));
            }, 1000);
        })
    }

    function inputFocus(e){
        setfocus(e.target.parentNode.classList.add('contact_focus'));
        setEmpty(e.target.parentNode.classList.add('contact_not-empty'));
    }

    function inputBlur(e){
            if(e.target.value == ""){
                setEmpty(e.target.parentNode.classList.remove('contact_not-empty'))
            }
            setfocus(e.target.parentNode.classList.remove('contact_focus'));
        }
    

    return(
        <>
        <Navbar active={'contact'} style={'#1A374D'}/>
            <div className="contact_background"></div>
    <header>
        <div className="contact_container">
            <ul>
                <li>
                    <Link to="/home" className="contact_logo a">
                        <div className="contact_images"  style={{marginRight: 0, position: 'relative', bottom: '2px', left: '2px'}}>
                            <img src="assets/Contactuus/images/Company-forDark.gif" alt="Company dark logo" className="contact_logo-forDark" title="Encyclopedia"/>
                            <img src="assets/Contactuus/images/company-forLight.gif" alt="Company light logo" className="contact_logo-forLight" title="Encyclopedia2"/>
                        </div>
                        <h2>BioUniverse<span>.</span></h2>
                    </Link>
                </li>
                <li>
                    <Link to="/home" className="contact_nav-link">Home</Link>
                </li>
                <li>
                    <Link to="/about" className="contact_nav-link">About</Link>
                </li>
                <li>
                    <Link to="/register" className="contact_nav-link">Login</Link>
                </li>
            </ul>
        </div>
    </header>

    <main>
        <section className="contact_contact">
            <div className="contact_container">
                <div className="contact_left">
                    <div className="contact_form-wrapper">
                        <div className="contact_contact-heading">
                            <h1>Let's Work together <span>.</span>
                            <div className="contact_theme_toggle_position">
                            <span onClick={changeTheme}>
                                <span className="contact_nav-link contact_theme-toggle">
                                    <i className="fa-solid fa-sun"></i>
                                    <i className="fa-solid fa-moon"></i>
                                </span>
                            </span>
                            </div>
                            </h1>
                            <p className="contact_text">Or reach us via: <a className='a' href="mailto:vishal.webengg+biouniverse@gmail.com">BioUniverse@mail.com</a></p>
                        </div>


                        <form onSubmit={contactUs} className="contact_contact-form">
                            <div className="contact_input-wrap">
                                <input className="contact_contact-input" autoComplete="off" name="First Name" type="text" required onFocus={inputFocus} onBlur={inputBlur} value={firstname} onChange={e => setFirstname(e.target.value)}/>
                                <label htmlFor="First Name">First Name</label>
                                <i className="contact_icon fa-solid fa-address-card"></i>
                            </div>
                            <div className="contact_input-wrap">
                                <input className="contact_contact-input" autoComplete="off" name="Last Name" type="text" onFocus={inputFocus} onBlur={inputBlur} value={lastname} onChange={e => setLastname(e.target.value)}/>
                                <label htmlFor="Last Name">Last Name</label>
                                <i className="contact_icon fa-solid fa-address-card"></i>
                            </div>
                            <div className="contact_input-wrap contact_w-100">
                                <input className="contact_contact-input" autoComplete="off" name="Email" type="email" required onFocus={inputFocus} onBlur={inputBlur} value={email} onChange={e => setEmail(e.target.value)}/>
                                <label htmlFor="Email">Email</label>
                                <i className="contact_icon fa-solid fa-envelope"></i>
                            </div>
                            <div className="contact_input-wrap contact_textarea contact_w-100">
                                <textarea name="Message" autoComplete="off" className="contact_contact-input" required onFocus={inputFocus} onBlur={inputBlur} value={message} onChange={e => setMessage(e.target.value)}></textarea>
                                <label htmlFor="Email">Message</label>
                                <i className="contact_icon fa-solid fa-inbox"></i>
                            </div>
                            <div className="contact_contact-buttons">
                                <button className="contact_btn contact_upload">
                                    <span>
                                        <i className="fa-solid fa-paperclip"></i>Add Attachment
                                    </span>
                                    <input type="file" name="attachment" onChange={e => setFiles(e.target.files)}/>
                                </button>
                                <input type="submit" value="Send message" className="contact_btn"/>
                            </div>
                        </form>


                    </div>
                </div>

                <div className="contact_right">
                    <div className="contact_image-wrapper">
                        <img src="assets/Contactuus/images/layer-4.webp" alt="img" className="contact_img"/>
                        <div className="contact_wave-wrap">
                            <svg className="contact_wave" viewBox="0 0 783 1536" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path id="wave" d="M236.705 1356.18C200.542 1483.72 64.5004 1528.54 1 1535V1H770.538C793.858 63.1213 797.23 196.197 624.165 231.531C407.833 275.698 274.374 331.715 450.884 568.709C627.393 805.704 510.079 815.399 347.561 939.282C185.043 1063.17 281.908 1196.74 236.705 1356.18Z" fill="#D9D9D9"/>
                                </svg>
                        </div>
                        <svg className="contact_dashed-wave" viewBox="0 0 345 877" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path id="dashed-wave" d="M0.5 876C25.6667 836.167 73.2 739.8 62 673C48 589.5 35.5 499.5 125.5 462C215.5 424.5 150 365 87 333.5C24 302 44 237.5 125.5 213.5C207 189.5 307 138.5 246 87C185 35.5 297 1 344.5 1"/>
                            </svg>
                    </div>
                </div>
            </div>
        </section>
        
        <ToastContainer
            position="bottom-right"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="light"
        />

    </main>
        </>
    );
}
